// src/utils/lineIds.js — GENERATED from functions/utils/lineIds.js. DO NOT EDIT BY HAND.
// Regenerate: node functions/scripts/buildWebLineIds.js   (lineidweb-9e4a2d17)
// src/utils/lineIds.test.js fails if this file is not exactly what the generator writes.
// What these helpers do and why: see the header of functions/utils/lineIds.js.

/* eslint-disable */
import { generateItemId } from './quoteSchema';

// LINEIDS-BODY-START
var LINE_ID_PATTERN = /^[A-Za-z0-9_-]{8,64}$/;
var DEFAULT_SELECTION_TYPE_FOR_TEMPLATES = 'required'; // KEEP IN SYNC with quoteSchema DEFAULT_SELECTION_TYPE

function isValidLineId(id) {
  return typeof id === 'string' && LINE_ID_PATTERN.test(id);
}

function isLineObject(line) {
  return line !== null && typeof line === 'object' && !Array.isArray(line);
}

// Per position: the line's lineId if it is valid AND the first line in the array to carry that
// value; otherwise null (missing, malformed or a duplicate). Lines are never changed.
function trustedLineIds(lines) {
  var seen = {};
  return (Array.isArray(lines) ? lines : []).map(function (line) {
    if (!isLineObject(line) || !isValidLineId(line.lineId) || seen[line.lineId]) return null;
    seen[line.lineId] = true;
    return line.lineId;
  });
}

// A fresh ID from newId() that is valid and not already in `taken` (an object used as a set).
function mintLineId(newId, taken) {
  for (var attempt = 0; attempt < 5; attempt++) {
    var id = newId();
    if (isValidLineId(id) && !taken[id]) { taken[id] = true; return id; }
  }
  throw new Error('lineIds: could not make a unique line ID');
}

// May this invoice be given line IDs? Never for imported / QuickBooks-origin history, for a
// written-off invoice, or once money has been paid (the rules lock those line arrays; their
// lines stay exactly as stored). docId may be null when unknown.
function invoiceTakesLineIds(docId, invoice) {
  var inv = invoice || {};
  if (typeof docId === 'string' && docId.indexOf('qbinv_') === 0) return false;
  if (inv.importId != null || inv.importedAt != null) return false;
  if (inv.status === 'Written Off' || inv.writtenOff === true) return false;
  if ((Number(inv.amountPaid) || 0) > 0) return false;
  return true;
}

// Every line ends up with a valid lineId unique in the array. A line that already has a trusted
// ID is returned as the SAME object (so it is untouched); any other line object is copied with a
// new lineId. Non-object entries pass through. Returns a new array; the input is never mutated.
function ensureLineIds(lines, newId) {
  if (!Array.isArray(lines)) return lines;
  var trusted = trustedLineIds(lines);
  var taken = {};
  trusted.forEach(function (id) { if (id) taken[id] = true; });
  return lines.map(function (line, i) {
    if (!isLineObject(line) || trusted[i]) return line;
    var out = Object.assign({}, line);
    out.lineId = mintLineId(newId, taken);
    return out;
  });
}

// One brand-new line: a fresh copy of `base` with its own lineId (never a shared object).
function newLine(base, newId) {
  var out = Object.assign({}, base || {});
  delete out.sourceLineId;
  out.lineId = mintLineId(newId, {});
  return out;
}

// Lines for a NEW document made from `sourceLines`, where newLines[i] was built from
// sourceLines[i] (however the caller built it). Each gets a new lineId; sourceLineId is the
// source line's trusted lineId, or is left off. Any lineId / sourceLineId the caller's copy
// carried over is replaced. Non-object entries pass through.
function attachLineage(newLines, sourceLines, newId) {
  if (!Array.isArray(newLines)) return newLines;
  var trusted = trustedLineIds(sourceLines);
  var taken = {};
  return newLines.map(function (line, i) {
    if (!isLineObject(line)) return line;
    var out = Object.assign({}, line);
    delete out.lineId;
    delete out.sourceLineId;
    out.lineId = mintLineId(newId, taken);
    if (trusted[i]) out.sourceLineId = trusted[i];
    return out;
  });
}

// Copy lines into a new document: mapFn(line, i) builds each copy (default: a shallow spread),
// then attachLineage gives it a new lineId and the sourceLineId.
function copyLinesWithLineage(sourceLines, newId, mapFn) {
  if (!Array.isArray(sourceLines)) return sourceLines;
  var copies = sourceLines.map(function (line, i) {
    if (mapFn) return mapFn(line, i);
    return isLineObject(line) ? Object.assign({}, line) : line;
  });
  return attachLineage(copies, sourceLines, newId);
}

// Re-copy `sourceLines` over a document that already holds copies of them (recurring template →
// an existing visit). A source line whose copy is already on the document keeps that copy's
// lineId (matched by sourceLineId), so the document's line keeps its ID for life; any other line
// gets a new one. Each result is a shallow copy of the source line plus lineId / sourceLineId.
function relinkCopies(sourceLines, existingCopies, newId) {
  if (!Array.isArray(sourceLines)) return sourceLines;
  var trustedSource = trustedLineIds(sourceLines);
  var trustedExisting = trustedLineIds(existingCopies);
  var existing = Array.isArray(existingCopies) ? existingCopies : [];
  var bySource = {};
  existing.forEach(function (copy, i) {
    if (trustedExisting[i] && isValidLineId(copy.sourceLineId) && !bySource[copy.sourceLineId]) {
      bySource[copy.sourceLineId] = trustedExisting[i];
    }
  });
  var reused = trustedSource.map(function (srcId) { return srcId && bySource[srcId] ? bySource[srcId] : null; });
  var taken = {};
  reused.forEach(function (id) { if (id) taken[id] = true; });
  return sourceLines.map(function (line, i) {
    if (!isLineObject(line)) return line;
    var out = Object.assign({}, line);
    delete out.lineId;
    delete out.sourceLineId;
    out.lineId = reused[i] || mintLineId(newId, taken);
    if (trustedSource[i]) out.sourceLineId = trustedSource[i];
    return out;
  });
}

// lineidweb-9e4a2d17 — saving a form's lines onto a COPY document (a recurring visit / exception)
// when some of them may still be the source's own lines (the form was filled from the template).
// A line carrying one of the source's trusted lineIds becomes a copy of it: new lineId,
// sourceLineId = that ID. Any other line is the copy's own and keeps a trusted lineId (or gets one).
function linesOntoCopy(lines, sourceLines, newId) {
  if (!Array.isArray(lines)) return lines;
  var sourceIds = {};
  trustedLineIds(sourceLines).forEach(function (id) { if (id) sourceIds[id] = true; });
  var trusted = trustedLineIds(lines);
  var taken = {};
  trusted.forEach(function (id) { if (id && !sourceIds[id]) taken[id] = true; });
  return lines.map(function (line, i) {
    if (!isLineObject(line)) return line;
    var id = trusted[i];
    if (id && !sourceIds[id]) return line;
    var out = Object.assign({}, line);
    delete out.lineId;
    delete out.sourceLineId;
    out.lineId = mintLineId(newId, taken);
    if (id) out.sourceLineId = id;
    return out;
  });
}

// lineidweb-9e4a2d17 — saving a form's lines back onto the SOURCE document (the recurring template)
// when the form may have been filled from one of its copies (a visit). A line that is one of the
// source's own lines keeps its ID; a line that is a copy of one (sourceLineId) takes that source
// line's ID back, with the source line's own sourceLineId; any other line keeps a trusted lineId of
// its own (or gets one) and no sourceLineId. Each source ID is used once. Without the source's
// current lines, use ensureLineIds instead.
function linesOntoSource(lines, sourceLines, newId) {
  if (!Array.isArray(lines)) return lines;
  var src = Array.isArray(sourceLines) ? sourceLines : [];
  var srcById = {};
  trustedLineIds(src).forEach(function (id, i) { if (id) srcById[id] = src[i]; });
  var trusted = trustedLineIds(lines);
  var taken = {};
  var target = lines.map(function (line, i) {
    if (!isLineObject(line)) return null;
    var id = trusted[i];
    if (id && srcById[id] && !taken[id]) { taken[id] = true; return id; }
    var back = isValidLineId(line.sourceLineId) ? line.sourceLineId : null;
    if (back && srcById[back] && !taken[back]) { taken[back] = true; return back; }
    return null;
  });
  return lines.map(function (line, i) {
    if (!isLineObject(line)) return line;
    var out = Object.assign({}, line);
    delete out.lineId;
    delete out.sourceLineId;
    if (target[i]) {
      out.lineId = target[i];
      if (isValidLineId(srcById[target[i]].sourceLineId)) out.sourceLineId = srcById[target[i]].sourceLineId;
      return out;
    }
    var own = trusted[i];
    if (own && !taken[own]) { taken[own] = true; out.lineId = own; } else { out.lineId = mintLineId(newId, taken); }
    return out;
  });
}

// taxlines-771ce983 — a line's Settings › Taxes code (salesTaxCodeId) and the copy of that code it
// keeps (salesTaxSnapshot), for the copy paths that list their fields one by one (to an invoice,
// Complete & Invoice, batch invoices, re-quote). The keys are added ONLY when the line has a code,
// so a line without one is copied exactly as before. functions/utils/lineTax.js has the rules.
function salesTaxFields(item) {
  var out = {};
  if (isLineObject(item) && typeof item.salesTaxCodeId === 'string' && item.salesTaxCodeId) {
    out.salesTaxCodeId = item.salesTaxCodeId;
    if (isLineObject(item.salesTaxSnapshot)) out.salesTaxSnapshot = item.salesTaxSnapshot;
  }
  return out;
}

// lineidweb-9e4a2d17 — quote → job lines (web CrmApp handleConvertToJob; callers pass the lines
// already filtered to the approved ones). The mapping is MOVED VERBATIM from there (its original
// indentation kept, so the move is provable byte for byte); then each line gets its own lineId and
// points back at the quote's line. itemId rides along unchanged, as before.
function jobLinesFromQuoteLines(quoteLines, newId) {
  var itemsForJob = Array.isArray(quoteLines) ? quoteLines : [];
  return attachLineage(itemsForJob.map(item => ({
                ...item,
                type: item.type || 'Service',
                taxCodeId: item.taxCodeId || '',
                taxExempt: item.taxExempt || false,
                addToCatalog: false
            })), itemsForJob, newId);
}

// lineidweb-9e4a2d17 — quote/job → invoice lines (web CrmApp createNewInvoiceFromSource; callers pass
// the lines already filtered to the approved ones). The mapping is MOVED VERBATIM from there; then
// each line gets its own lineId and points back at the source line.
function invoiceLinesFromSourceLines(sourceLines, newId) {
  var sourceItems = Array.isArray(sourceLines) ? sourceLines : [];
  return attachLineage(sourceItems.map(item => ({
            name: item.name || '',
            description: item.description || '',
            quantity: Number(item.quantity) || 1,
            price: Number(item.price) || 0,
            type: item.type || 'Service',
            taxCodeId: item.taxCodeId || '',
            taxExempt: item.taxExempt || false,
            taxExemptionNumber: item.taxExemptionNumber || '',
            serviceId: item.serviceId || '',
            ...salesTaxFields(item), // taxlines-771ce983 — only when the line has a code
            // Phase 4.5: carry itemId so the audit chain holds quote → invoice
            itemId: item.itemId || ''
        })), sourceItems, newId);
}

// THE one template-apply function. Every template line becomes a new line with a fresh lineId (and
// no sourceLineId: a template is a blueprint, not a tracked document). Tax Exempt (a real `true`
// only) and the line tax code are always carried; a Settings › Taxes code (salesTaxCodeId) too, but
// NOT its kept copy: a new line takes the code's rates as they are now (taxlines-771ce983; 'planner'
// and 'copy' copy the whole line, as they always have). Targets reproduce each editor's existing rules:
//   quote   — quantity as stored; + a fresh itemId, selectionType, parentItemId remapped to the
//             new itemIds (web QuoteFormModal / phone QuoteBuilder)
//   job     — Hour lines priced by opts.durationMins (the job's duration, used as given); + unit,
//             crewGroupId, crewGroupName from opts.routeGroups (web JobFormModal)
//   invoice — quantity as stored (web InvoiceFormModal)
//   booking — Hour lines priced by the template line's own durationMins (default 60)
//             (bookNow, CrmApp request prefill / Book Now). With opts.newItemId (Book Now only —
//             bnitem-4d7a2e95), each line also gets the quote target's itemId, selectionType and
//             remapped parentItemId, so the customer can approve it in the portal; without it,
//             the output is exactly as before (the request pre-fill; the estimate form adds them)
//   planner — the WHOLE template line copied (web Weekly Planner), Hour lines priced by
//             opts.durationMins; the template's own lineId / sourceLineId are not copied. itemId is
//             FROZEN: a template line's itemId is copied exactly as the Planner always copied it.
//   copy    — the WHOLE template line copied over opts.base (phone job builder:
//             `{ ...DEFAULT_LINE_ITEM, ...item }`), quantity as stored — so Tax Exempt and the tax
//             code ride along as stored; the template's own lineId / sourceLineId are not copied,
//             itemId is copied as is (lineidphone-6c1f7b04)
// A non-object template entry is skipped.
function templateLinesFor(templateLines, opts) {
  var o = opts || {};
  var target = o.target;
  if (['quote', 'job', 'invoice', 'booking', 'planner', 'copy'].indexOf(target) < 0) throw new Error('templateLinesFor: unknown target ' + target);
  var newId = o.newId;
  var items = (Array.isArray(templateLines) ? templateLines : []).filter(isLineObject);
  var takenLineIds = {};
  var takenItemIds = {};
  var itemIdMaker = target === 'quote' ? (o.newItemId || newId)
    : (target === 'booking' && typeof o.newItemId === 'function' ? o.newItemId : null); // bnitem-4d7a2e95
  var newItemIds = itemIdMaker ? items.map(function () { return mintLineId(itemIdMaker, takenItemIds); }) : [];
  var oldToNewItemId = {};
  if (itemIdMaker) {
    items.forEach(function (item, idx) { if (item.itemId) oldToNewItemId[item.itemId] = newItemIds[idx]; });
  }
  return items.map(function (item, idx) {
    if (target === 'planner' || target === 'copy') {
      var copy = Object.assign({}, target === 'copy' ? (o.base || {}) : {}, item);
      delete copy.lineId;
      delete copy.sourceLineId;
      if (target === 'planner') copy.quantity = item.unit === 'Hour' ? (o.durationMins / 60) : (item.quantity || 1);
      return Object.assign({ lineId: mintLineId(newId, takenLineIds) }, copy);
    }
    var quantity;
    if (target === 'job') quantity = item.unit === 'Hour' ? o.durationMins / 60 : (item.quantity || 1);
    else if (target === 'booking') quantity = item.unit === 'Hour' ? (item.durationMins || 60) / 60 : (item.quantity || 1);
    else quantity = item.quantity || 1;
    var line = {
      lineId:       mintLineId(newId, takenLineIds),
      serviceId:    item.serviceId   || '',
      name:         item.name        || '',
      description:  item.description || '',
      quantity:     quantity,
      price:        item.price       || 0,
      type:         item.type        || 'Service',
      taxCodeId:    item.taxCodeId   || '',
      taxExempt:    item.taxExempt === true,
      addToCatalog: false,
    };
    if (isLineObject(item) && typeof item.salesTaxCodeId === 'string' && item.salesTaxCodeId) line.salesTaxCodeId = item.salesTaxCodeId; // taxlines-771ce983
    if (itemIdMaker) {
      line.itemId = newItemIds[idx];
      line.selectionType = item.selectionType || DEFAULT_SELECTION_TYPE_FOR_TEMPLATES;
      line.parentItemId = item.parentItemId && oldToNewItemId[item.parentItemId] ? oldToNewItemId[item.parentItemId] : null;
    }
    if (target === 'job') {
      var groups = Array.isArray(o.routeGroups) ? o.routeGroups : [];
      var group = item.crewGroupId ? groups.find(function (g) { return g && g.id === item.crewGroupId; }) : null;
      line.unit = item.unit || 'Unit';
      line.crewGroupId = item.crewGroupId || '';
      line.crewGroupName = item.crewGroupId ? ((group && group.name) || item.crewGroupName || '') : '';
    }
    return line;
  });
}

// Tests only: the lines with lineId / sourceLineId removed, to compare against older output.
function stripLineIds(lines) {
  if (!Array.isArray(lines)) return lines;
  return lines.map(function (line) {
    if (!isLineObject(line)) return line;
    var out = Object.assign({}, line);
    delete out.lineId;
    delete out.sourceLineId;
    return out;
  });
}
// LINEIDS-BODY-END

// The web ID source: a UUID (crypto.randomUUID where the browser has it, else the same
// fallback itemId uses — see quoteSchema's generateItemId).
export const newLineId = () => generateItemId();

export { isValidLineId, trustedLineIds, invoiceTakesLineIds, ensureLineIds, newLine, attachLineage, copyLinesWithLineage, relinkCopies, linesOntoCopy, linesOntoSource, jobLinesFromQuoteLines, invoiceLinesFromSourceLines, templateLinesFor, stripLineIds, salesTaxFields };
